var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DateFilter',{on:{"filter":_vm.onFilter,"clear":_vm.onClear}})
}
var staticRenderFns = []

export { render, staticRenderFns }